export default __webpack_public_path__ + "static/char-s-02-cht-e9dd7dff7bf66b3e40c834189bc20d0c.png";